<template>
  <div class="bg-container page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>

    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <img
              src="/img/newLogin/download.png"
              @click="back()"
              style="width: 20px; height: 15px;"
            />
          </template>

          <!-- ✅ 右上角語言入口隱藏：整段移除 -->
          <!--
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <img src="/img/newLogin/icon_lang.png" />
            </div>
          </template>
          -->
        </van-nav-bar>

        <div class="wrapper">
          <div class="logon_box">
            <img src="/img/clogo.png" class="login-logo" />
            <div class="cc">
              {{ $t("q1") }}
            </div>
          </div>

          <div class="loginForm">
            <!-- ✅ 账号：不改大小，只改“输入文字左对齐” -->
            <van-field
              v-model="username"
              clearable
              input-align="left"
              class="input"
              :placeholder="$t('auth.username_place')"
            />

            <!-- ✅ 密码：不改大小，只改“输入文字左对齐” -->
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="left"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>

            <!-- 登录按钮保持不动 -->
            <van-button class="login-btn" type="primary" size="normal" @click="doLogin()">
              {{ $t("auth.login") }}
            </van-button>

            <!-- ✅ 忘记密码删除 ✅ 免费注册改为按钮 -->
            <van-button class="register-btn" plain type="default" size="normal" @click="toRegister()">
              {{ $t("auth.no_account") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      password: this.inputValue,
      passwordType: "password",
    };
  },

  created() {
    // ✅ 已登入就返回
    if (localStorage.getItem("token")) {
      return window.history.back();
    }

    // ✅ 只用繁中（台灣）：避免日文出現
    localStorage.setItem("lang", "zh");
    if (this.$i18n) this.$i18n.locale = "zh";
  },

  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },

    // ✅ 註冊
    toRegister() {
      // 你的路由如果不是 /Register，改成你的實際路由
      this.$router.push({ path: "/Register" });
    },

    doLogin() {
      if (!this.username) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }

      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* ✅ 字体改成示例图那种常见移动端字体栈（不动你原来的字号） */
.page,
.bg-container,
.login,
.wrapper {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial,
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

/* 你原来的颜色保留 */
::v-deep .van-field__control {
  color: #e6b98a;
}

/* ✅ 关键：输入内容与 placeholder 左对齐（不改变 input 自己的 padding/字号） */
::v-deep .van-field__control {
  text-align: left !important;
}

/* 如果你发现 placeholder 仍不对齐，可保留这个（不同 Vant 版本有差异） */
::v-deep input::placeholder {
  text-align: left !important;
}

.dong_box {
  height: 100%;
  @keyframes bg-data-v-8175861c {
    0%,
    100% {
      background-position-x: 0;
    }
    50% {
      background-position-x: 100%;
    }
  }
  .dong_i {
    height: 100%;
    width: auto;
    animation: bg-data-v-8175861c 20s linear infinite;
    background: url(/img/newLogin/login.jpg) no-repeat 0 0;
    background-size: auto 100%;
  }
}

.login {
  height: 100%;
}

.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
  border-bottom: solid 1px transparent;
}

.bg-container .bg-wrapper {
  background: #00000082 no-repeat 0 0;
  background-size: 100% 100%;
}

.logon_box {
  text-align: center;
  .cc {
    padding-top: 30px;
    color: #ccc;
  }
}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.login .wrapper .loginForm {
  padding: 20px 60px;
}

/* ✅ 不改你原 input 的大小/样式（保持原样） */
.login .wrapper .loginForm .input {
  padding: 26px 20px;
  margin-top: 40px;
  border-radius: 10px;
  text-align: center; /* 外层保持原样，真正输入文字我们已用 ::v-deep 强制 left */
  font-size: 30px;
  width: 100% !important;
  height: 100%;
  box-sizing: border-box;
  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid #766350;
  color: #e6b98a;
}

/* ✅ 删除忘记密码区域，所以 c_bott 可以删掉；不删也没影响 */
/*
.c_bott {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  color: #bfa77c;
  font-size: 25px;
}
*/

::v-deep .van-cell::after {
  display: none;
}

::v-deep .van-field__right-icon .van-icon,
::v-deep .van-icon {
  font-size: 50px;
}

/* 登录按钮保持原样 */
.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 80px;
  border-radius: 50px;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}

/* ✅ 免费注册按钮：不动你的主按钮/输入框/LOGO，只给注册按钮做一个“目标站那种描边按钮” */
.register-btn {
  margin-top: 22px;
  width: 100%;
  height: 80px;
  border-radius: 50px;

  background: transparent !important;
  border: 2px solid rgba(255, 255, 255, 0.65) !important;
  color: rgba(255, 255, 255, 0.95) !important;

  font-size: 30px;
  font-weight: bolder;
}

/* plain 按钮默认样式清理 */
::v-deep .register-btn.van-button--plain {
  background: transparent !important;
}
.logon_box {
  text-align: center;

  .login-logo {
    width: 300px;         /* ✅ 调小：右图差不多就是 88~96 之间 */
    height: 300px;
    object-fit: cover;

    border-radius: 58px; /* ✅ 圆角像右图：建议 22~28 */
    overflow: hidden;

    /* 可选：看起来更像右图“App 图标” */
    box-shadow: 0 10px 26px rgba(0,0,0,.35);
  }

  .cc {
    padding-top: 30px;
    color: #ccc;
  }
}

</style>
